import { fetchCustomizing } from '../../lib/services/mobivers/api';
import {CustomizingState, DispatchThunkAny} from '../../types/redux';

export const FETCH_CUSTOMIZING_SUCCESS = 'FETCH_CUSTOMIZING_SUCCESS';
export const CUSTOMIZING_LOADING_IN_PROGRESS = 'CUSTOMIZING_LOADING_IN_PROGRESS';

/**
 * Fetch customizing from backend and set status
 * @param customizingId the customizing ID
 */
export function updateCustomizing(customizingId?: string): any {
	return async (dispatch: DispatchThunkAny) => {
		try {
			if (process.env.REACT_APP_CUSTOMIZING_ENABLED?.toLowerCase() === 'true' && null!==customizingId ) {
				dispatch({ type: CUSTOMIZING_LOADING_IN_PROGRESS });
				const data = customizingId ? await fetchCustomizing(customizingId) : {};
				dispatch({ type: FETCH_CUSTOMIZING_SUCCESS, payload: {...data, name: customizingId?.toLowerCase()} });
			} else {
				dispatch({ type: FETCH_CUSTOMIZING_SUCCESS, payload: {} });
			}
		} catch (error) {
			console.error('Cannot fetch customizing', error);
		}
	};
}


export const getUrlDepandOnCustomization = (customizing: CustomizingState, currentUrl= '') :string => {
	const custId = customizing?.name?.toLowerCase() ;
	if(currentUrl!==undefined && custId==="bank11" ) {
		currentUrl = currentUrl.replace('bo','bo-bank11');
		currentUrl = currentUrl.replace('verkauf','bank11');
	}
	return currentUrl;
}
